module.exports = __webpack_public_path__ + "static/media/tan.cf9c79f4.svg";